export default __webpack_public_path__ + "static/media/site-vpm-1436x1836-2kbs-hiexp.f1ba9dfe.mp4";